import React from "react";
import Card from "./card";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
// blog_image_1-375x211
const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 5,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 3,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};
const Blog = () => {
  return (
    <div className="bg-[#e6e8f0] px-5 pb-5">
      <div className="flex justify-between items-center ">
        <p className="my-4 font-rubik font-bold text-2xl">Recent Blog</p>
      </div>

      <div className="flex flex-wrap justify-center md:justify-between gap-2">
          <Card />
          <Card />
          <Card />
          <Card />
      </div>
    </div>
  );
};

export default Blog;
